import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { Environment } from "../app/model/environment.model";

export const environment: Environment = {
    name: 'TEST',
    titlePrefix: 'Test ',
    cognitoConfig: {
        Auth: {
            Cognito: {
                userPoolId: "eu-central-1_As6tIlGtX",
                userPoolClientId: "45ondqpfpeae53qlnf31anejbs",
                signUpVerificationMethod: "code"
            }
        }
    },
    FE: {
        url: "https://musterbehoerde.formular-demo.de",
        ffaGlobalsLoadTimeSeconds: 30,
        ffaSupportEMail: "info@virtuelle-foerderungsanstalt.de",
    },
    FMS: {
        origin: "https://formular-demo.de",
        formularServerPath: "/TestForms",
        gatewayServerPath: "/TestGateway",
        areaShortname: "MB",
        formTecId: "7",
        useDevOnLocal: false,
        setMaxWaitTimeForPageChangeInSeconds: 10,
    },
    AWS: {
        apiGatewayUrl: "https://musterbehoerde-api.formular-demo.de"
    },
    imports: [
        StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
            logOnly: false, // Restrict extension to log-only mode
        })
    ],
    idleManagement: {
        // The max time a user can be idle before he gets logged out in minutes
        idleTimeoutMin: 15,
        // The time that should pass between updates to the active status in seconds.
        lastTimeActiveDebounceTimeSec: 1,
    },
    csvManagement: {
        csvFilenames: ["foerderart.csv", "foerderbereich.csv", "freigabe.csv", "nebenantragsart.csv"],
    },
    maintenanceEnv: {
        maintenanceCheckTimeInSec: 60
    },
    version: '1.7.1'
}
